export const DATE_PICKER_LOCALE = 'de-DE';

export const DATE_PICKER_PLACEHOLDER = 'TT.MM.JJJJ';

/** Years per page of the year view: four rows of three. */
export const YEAR_PAGE_SIZE = 12;

export const DATE_PICKER_LABELS = {
    open: 'Kalender öffnen',
    close: 'Kalender schließen',
    dialog: 'Datum wählen',
    previousMonth: 'Vorheriger Monat',
    nextMonth: 'Nächster Monat',
    previousYear: 'Vorheriges Jahr',
    nextYear: 'Nächstes Jahr',
    previousYears: 'Vorherige Jahre',
    nextYears: 'Nächste Jahre',
    chooseMonth: 'Monat und Jahr wählen',
    chooseYear: 'Jahr wählen',
    clear: 'Löschen',
    today: 'Heute',
    invalid: 'Bitte geben Sie ein gültiges Datum im Format TT.MM.JJJJ ein.',
    fromDay: (day: string) => `Bitte wählen Sie ein Datum ab dem ${day}.`,
    untilDay: (day: string) => `Bitte wählen Sie ein Datum bis zum ${day}.`,
    betweenDays: (min: string, max: string) => `Bitte wählen Sie ein Datum zwischen dem ${min} und dem ${max}.`,
} as const;

const MONTH_TITLE = new Intl.DateTimeFormat(DATE_PICKER_LOCALE, { month: 'long', year: 'numeric' });
const LONG_DAY = new Intl.DateTimeFormat(DATE_PICKER_LOCALE, { day: 'numeric', month: 'long', year: 'numeric' });
const LONG_MONTH = new Intl.DateTimeFormat(DATE_PICKER_LOCALE, { month: 'long' });
const SHORT_MONTH = new Intl.DateTimeFormat(DATE_PICKER_LOCALE, { month: 'short' });
const LONG_WEEKDAY = new Intl.DateTimeFormat(DATE_PICKER_LOCALE, { weekday: 'long' });
const SHORT_WEEKDAY = new Intl.DateTimeFormat(DATE_PICKER_LOCALE, { weekday: 'short' });

export function monthTitle(year: number, month: number): string {
    return MONTH_TITLE.format(new Date(year, month, 1));
}

export function longDay(date: Date): string {
    return LONG_DAY.format(date);
}

/** Monday first; 1 January 2024 was a Monday. */
export const WEEKDAYS = Array.from({ length: 7 }, (_, index) => {
    const date = new Date(2024, 0, 1 + index);

    return { short: SHORT_WEEKDAY.format(date).replace('.', ''), long: LONG_WEEKDAY.format(date) };
});

export const MONTHS = Array.from({ length: 12 }, (_, index) => {
    const date = new Date(2024, index, 1);

    return { short: SHORT_MONTH.format(date).replace('.', ''), long: LONG_MONTH.format(date) };
});
